import React from 'react'
import { Backdrop, CircularProgress, styled } from '@mui/material'

const StyledBackdrop = styled(Backdrop)`
    z-index: 99999;
`

interface Props {
    open?: boolean
}

export const CircularProgressBackdrop: React.VFC<Props> = ({ open = true }: Props) => {
    if (!open) {
        return null
    }

    return (
        <StyledBackdrop open>
            <CircularProgress color="inherit" />
        </StyledBackdrop>
    )
}

export type { Props as CircularProgressBackdropProps }
